import { Controller } from "@hotwired/stimulus"

// Fetches a turbo-stream URL the moment it is connected, renders the answer and removes
// itself. For a server response that has to open something it cannot render itself: the
// Stundenzettel Matrix answers typed hours whose template still needs the form with this
// element, pointed at the new-entry drawer on the times it worked out
// (ConfigurableTimeSheets::MatrixCells#matrix_cell_form_loader). A page that opens a drawer
// from a query parameter (a damage from the link in its mail, `open_damage`) names it in
// removeParam, so a reload does not open the drawer again.
export default class extends Controller {
  static values = { url: String, removeParam: String }

  async connect() {
    const url = this.urlValue
    this.element.remove()
    if (this.removeParamValue) this.removeQueryParam(this.removeParamValue)
    if (!url) return

    try {
      const response = await fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "text/vnd.turbo-stream.html" },
      })
      const contentType = response.headers.get("Content-Type") || ""
      if (contentType.includes("text/vnd.turbo-stream.html")) {
        window.Turbo.renderStreamMessage(await response.text())
      } else {
        console.error("Unexpected response loading stream:", response.status)
      }
    } catch (error) {
      console.error("Error loading stream:", error)
    }
  }

  removeQueryParam(name) {
    const location = new URL(window.location.href)
    location.searchParams.delete(name)
    history.replaceState(history.state, "", location.toString())
  }
}
